import { render, staticRenderFns } from "./CollegeNews.vue?vue&type=template&id=3c726572&scoped=true"
import script from "./CollegeNews.vue?vue&type=script&lang=js"
export * from "./CollegeNews.vue?vue&type=script&lang=js"
import style0 from "./CollegeNews.vue?vue&type=style&index=0&id=3c726572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c726572",
  null
  
)

export default component.exports